import initHotelInfoAccordion from 'js/scenes/HotelInfoAccordion';

export {scrollToSection} from 'js/scenes/HotelInfoAccordion'
export default function (el) {
  initHotelInfoAccordion(el)
}
